<template>
  <v-navigation-drawer
    overlay-opacity=".8"
    disable-resize-watcher
    light
    left
    temporary
    app
    style="z-index: 5"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <v-list color="white">
      <v-list-item
        v-for="(link, i) in links"
        :key="i"
        :to="link.to"
        router
        exact
        color="primary"
      >
        <v-list-item-action>
          <v-img style="height: auto; width: 15px" :src="link.src"></v-img>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title :id="link.id" v-text="link.title" />
        </v-list-item-content>
      </v-list-item>
      <v-list-item v-if="userIsAuthenticated" @click="onLogout" color="primary">
        <v-list-item-action>
          <v-img
            :src="
              require('@/assets/fontawesome/arrow-up-left-from-circle-duotone.svg')
            "
          ></v-img>
        </v-list-item-action>
        <v-list-item-content> Logout </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
export default {
  name: 'HomeDrawer',
  data() {
    return {
      links: [
        {
          title: 'Home',
          to: '/',
          src: require('@/assets/fontawesome/house-chimney-duotone.svg'),
          id: 'home-left-nav',
        },
        {
          title: 'Become a Lender',
          to: '/join',
          src: require('@/assets/fontawesome/users-duotone.svg'),
          id: 'become-lender-left-nav',
        },
        {
          title: 'Items',
          to: '/items',
          src: require('@/assets/fontawesome/camera-retro-duotone.svg'),
          id: 'become-lender-left-nav',
        },
        {
          title: 'Requests',
          to: '/item-requests',
          src: require('@/assets/fontawesome/square-question-duotone.svg'),
          id: 'requests-left-nav',
        },
        {
          title: 'List an Item',
          to: '/items/new',
          src: require('@/assets/fontawesome/octagon-plus-duotone.svg'),
          id: 'list-item-left-nav',
        },
        {
          title: 'About us',
          to: '/about',
          src: require('@/assets/fontawesome/chart-network-duotone.svg'),
          id: 'about-us-left-nav',
        },
        // {
        //   title: "Contact",
        //   to: "/",
        //   src: require("@/assets/fontawesome/house-duotone.svg")
        // },
        {
          title: 'FAQ',
          to: '/FAQ',
          src: require('@/assets/fontawesome/question-duotone.svg'),
          id: 'faq-left-nav',
        },
        {
          title: 'Contact',
          to: '/contact-us',
          src: require('@/assets/fontawesome/phone-flip-duotone.svg'),
          id: 'contact-us-left-nav',
        },
      ],
    };
  },
  computed: {
    userIsAuthenticated() {
      return (
        this.$store.getters.user !== null &&
        this.$store.getters.user !== undefined
      );
    },
  },
  methods: {
    onLogout() {
      this.$store.dispatch('logout');
      this.$router.push('/');
    },
  },
  props: {
    items: {
      type: Array,
      default: () => [],
    },
  },
};
</script>
